import { CompanyLegalBeneficiary } from '__generated__/GQL';

/**
 * Out of a list of `legalBeneficiaries`,
 * return the one whose representing the current user, if there is one.
 */
const getCurrentLegalBeneficiary = <
  TLegalBeneficiary extends Pick<
    CompanyLegalBeneficiary,
    'companyLegalBeneficiaryId' | 'isCurrentUser'
  >,
>(
  companyLegalBeneficiaries: TLegalBeneficiary[],
) => companyLegalBeneficiaries.find(({ isCurrentUser }) => isCurrentUser);

export default getCurrentLegalBeneficiary;
